import { Reducer, SliceCaseReducers } from "@reduxjs/toolkit";
import { FeedComponentInfo } from "../../..";
import { RootState } from "../../../../Store";
import { createAsyncEntitySlice } from "../../../../Store/Entities/createAsyncEntitySlice";
import { entityByIdWithStatusHookFactory } from "../../../../Store/Entities/entityByIdWithStatusHookFactory";
import { EnqueueFetcher } from "../../../../Store/Thunks/enqueueFetcher";
import { fetchFeedComponentByIdsThunk } from "../../../../Store/Thunks/feedComponentsByIds";
import { AsyncEntityState } from "../../../../Store/Thunks/asyncEntityStateUtil";



// Explicit typing is required
const {reducer, actions, entityAdapter: feedComponentEntityAdapter, getSelectors} = createAsyncEntitySlice<FeedComponentInfo, number,SliceCaseReducers<AsyncEntityState<FeedComponentInfo, number>>, FeedComponentInfo>({
  name: "feedComponents",
  reducers: {},
  fetchByIdsThunk: fetchFeedComponentByIdsThunk,
  selectId: (feedComponent: FeedComponentInfo) => feedComponent.id
})

export const feedComponentReducer = reducer as Reducer<AsyncEntityState<FeedComponentInfo, number>>;
const selectState = (state:RootState) => state.graphQlData.feedComponents;

const {clearPendingIds, addLoadingIds, addPendingId} = actions;
export const {selectById: SelectFeedComponentById, selectAll: SelectAllFeedComponents} = feedComponentEntityAdapter.getSelectors(selectState);

const feedComponentFetcher = new EnqueueFetcher(fetchFeedComponentByIdsThunk, selectState, clearPendingIds, addPendingId, addLoadingIds );

const selectLoadingIds = getSelectors(selectState).selectLoadingIds;

export const useFeedComponentById = entityByIdWithStatusHookFactory(feedComponentFetcher.enqueueFetchById, SelectFeedComponentById, selectLoadingIds);